@let content = this.content$() | async;
<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    <cam-empty [isEmpty]="!content">
      @if (content) {
        <cam-rich-text [richText]="content.Content"></cam-rich-text>

        <div class="scroll-arrow">
          <cam-button type="secondary" [options]="{ circular: 'small' }" (action)="this.scrollToBottom()">
            <cam-font-icon name="arrow-small-bottom" type="lg"></cam-font-icon>
          </cam-button>
        </div>

        <div #bottomCheckbox class="checkbox ta-r mt-space-lg">
          <cam-input-checkbox
            [input]="this.checkbox"
            [standalone]="true"
            (valueChanged)="this.acceptation.emit($event)"
          ></cam-input-checkbox>
        </div>
      }
    </cam-empty>
  </cam-error>
</cam-loader>
